import type { SVGProps } from "react"
const Bell = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.80094 9.60322C4.25738 5.41917 7.79108 2.25 12 2.25C16.2088 2.25 19.7425 5.41916 20.199 9.60322L20.8731 15.7831C21.0022 16.9665 20.0754 18 18.8849 18H16.8424C16.2874 20.1565 14.3298 21.75 12 21.75C9.67015 21.75 7.71253 20.1565 7.15747 18H5.11498C3.92455 18 2.99767 16.9665 3.12677 15.7831L3.80094 9.60322ZM9.27197 18C9.74598 19.0328 10.7892 19.75 12 19.75C13.2107 19.75 14.2539 19.0328 14.7279 18H9.27197ZM12 4.25C8.8117 4.25 6.1349 6.65066 5.78914 9.82011L5.11498 16L18.8849 16L18.2108 9.82011C17.865 6.65066 15.1882 4.25 12 4.25Z"
      fill="currentColor"
    />
  </svg>
)
export default Bell
